import intl from "../i18n/i18n";

export const routeName = {
    systems: intl.formatMessage({ id: "app-drawer.tab-content.links.system" }),
    systemGroups: intl.formatMessage({ id: "app-drawer.tab-content.links.system-groups" }),
    busynessProcesses: intl.formatMessage({ id: "app-drawer.tab-content.links.busyness-process" }),
    users: intl.formatMessage({ id: "app-drawer.tab-content.links.user" }),
    criticalRoles: intl.formatMessage({ id: "app-drawer.tab-content.links.critical-role" }),
    criticalProfiles: intl.formatMessage({ id: "app-drawer.tab-content.links.critical-profile" }),
    functions: intl.formatMessage({ id: "app-drawer.tab-content.links.function" }),
    matrixHeaders: intl.formatMessage({ id: "app-drawer.tab-content.links.matrix-header" }),
    risks: intl.formatMessage({ id: "app-drawer.tab-content.links.risk" }),
    variants: intl.formatMessage({ id: "app-drawer.tab-content.links.variant" }),
    integrations: intl.formatMessage({ id: "app-drawer.tab-content.links.integrations" }),
    locks: intl.formatMessage({ id: "app-drawer.tab-content.links.locks" }),
    admin: intl.formatMessage({ id: "app-drawer.tab-content.links.admin" }),
    riskLevels: intl.formatMessage({ id: "app-drawer.tab-content.links.risk-levels" }),
    compensationProcedures: intl.formatMessage({ id: "app-drawer.tab-content.links.compensation-procedures" }),
    customRoles: intl.formatMessage({ id: "app-drawer.tab-content.links.custom-roles" }),
    userLevel: intl.formatMessage({ id: "app-drawer.tab-content.links.user-level" }),
    roleLevel: intl.formatMessage({ id: "app-drawer.tab-content.links.role-level" }),
    reportSummary: intl.formatMessage({ id: "app-drawer.tab-content.links.report-summary" }),
    allTasks: intl.formatMessage({ id: "app-drawer.tab-content.links.all-tasks" }),
    myTasks: intl.formatMessage({ id: "app-drawer.tab-content.links.my-tasks" }),
    createNewRole:intl.formatMessage({id:"app-drawer.tab-content.links.create-new-role"}),
    testingPreparation:intl.formatMessage({id:"app-drawer.tab-content.links.testing-preparation"}), 
};
